var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66683 0.925906C9.66683 1.0864 9.6091 1.22529 9.49365 1.34257L5.41032 5.49072C5.29487 5.60801 5.15815 5.66665 5.00016 5.66665C4.84218 5.66665 4.70546 5.60801 4.59001 5.49072L0.506673 1.34257C0.391222 1.22529 0.333496 1.0864 0.333496 0.925906C0.333496 0.765412 0.391222 0.626523 0.506673 0.509239C0.622125 0.391955 0.758843 0.333313 0.916829 0.333313H9.0835C9.24148 0.333313 9.3782 0.391955 9.49365 0.509239C9.6091 0.626523 9.66683 0.765412 9.66683 0.925906Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/select_arrow.b0257c96f91696c3fd609e77436100c2.svg";
export { ForwardRef as ReactComponent };